export default __webpack_public_path__ + "static/media/step3.726ccb31.png";